// =============================================================================
// actions/siteActions.js
//
// Thunk para carregar a lista de sites com coordenadas. Catch defensivo:
// se `err` chega undefined (ex: throw no proprio thunk antes do axios),
// nao rebenta com "Cannot read 'response' of undefined".
// =============================================================================
import {
	SITES_FETCH_REQUEST, SITES_FETCH_SUCCESS, SITES_FETCH_FAILURE,
} from '../constants/kpiConstants';
import { apiFetchSites } from '../requests/kpiRequests';

function extractErrorMessage(err) {
	if (!err) return 'Erro desconhecido';
	if (err.response && err.response.data) {
		if (err.response.data.error)   return err.response.data.error;
		if (err.response.data.message) return err.response.data.message;
		if (typeof err.response.data === 'string') return err.response.data;
	}
	if (err.message) return err.message;
	return 'Erro desconhecido';
}

export function fetchSites() {
	return async function (dispatch) {
		dispatch({ type: SITES_FETCH_REQUEST });
		try {
			const res = await apiFetchSites();
			dispatch({ type: SITES_FETCH_SUCCESS, payload: (res && res.data) || [] });
		} catch (err) {
			dispatch({
				type: SITES_FETCH_FAILURE,
				payload: extractErrorMessage(err),
			});
		}
	};
}